import styled from 'styled-components';

export const PriceContainer = styled.div<{ $displayMode: 'rows' | 'cols' }>`
	display: flex;
	flex-direction: ${({ $displayMode }) => ($displayMode === 'cols' ? 'column' : 'row')};
	gap: ${({ $displayMode }) => ($displayMode === 'rows' ? '4px' : '0')};
	flex-wrap: wrap;
`;
